
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/date-pickers/multi-section-digital-clock",
      function () {
        return require("private-next-pages/x/api/date-pickers/multi-section-digital-clock.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/date-pickers/multi-section-digital-clock"])
      });
    }
  